import React, {
  ComponentType,
  FC,
  Fragment,
  PropsWithChildren,
  useMemo,
} from 'react';
import BaseLayout from '@/layouts/Base';

export interface ILayoutContainerProps {
  Component: PageComponent;
}

const LayoutContainer: FC<PropsWithChildren<ILayoutContainerProps>> = ({
  Component,
  children,
}) => {
  const { BaseLayoutComponent, ChildLayoutComponent } = useMemo(() => {
    const BaseLayoutComponent: ComponentType<PropsWithChildren<any>> =
      Component?.layout === null ? Fragment : BaseLayout;

    const ChildLayoutComponent: ComponentType<PropsWithChildren<any>> =
      Component?.layout ?? Fragment;

    return { BaseLayoutComponent, ChildLayoutComponent };
  }, [Component]);

  return (
    <BaseLayoutComponent {...(Component?.layoutProps || {})}>
      <ChildLayoutComponent {...(Component?.layoutProps || {})}>
        {children}
      </ChildLayoutComponent>
    </BaseLayoutComponent>
  );
};

export default LayoutContainer;
